<template>
   <el-card>
    <!-- 查詢表單 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
        <el-form-item label="权限名称:" >
          <el-input v-model="searchFactor.permissionName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCreatePermission">创建</el-button>
        </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      :highlight-current-row ="false"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 90%; ">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="permissionName"
        label="权限名称"
        min-width="200px">
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        min-width="120px">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180px">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="180px"
        label="更新时间">
      </el-table-column>
      <el-table-column
        prop="url"
        min-width="250px"
        label="资源地址" >
      </el-table-column>
      <el-table-column
        prop="remark"
        min-width="300px"
        label="备注" >
      </el-table-column>
      <el-table-column label="操作" min-width="240px" >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        layout="total,prev, pager, next"
        :current-page.sync="pager.currentPage"
        @current-change="handleCurrentChange"
        style="margin: 10px"
        :page-size="pager.pageSize"
        :total="pager.totalCount" >
    </el-pagination>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.editPermissionDialogVisible" v-on:close ="clearEditPermissionInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 权限[{{ editPermissionForm.permissionName }}] 信息变更 </span>
      </div>
      <el-form :model="editPermissionForm" label-width="20%"> 
          <el-form-item label="权限名称:" style="width:80%">
              <el-input v-model="editPermissionForm.permissionName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="资源地址:" style="width:80%">
              <el-input v-model="editPermissionForm.url" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注:" style="width:80%">
              <el-input type="textarea" v-model="editPermissionForm.remark" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.createPermissionDialogVisible" v-on:close ="clearCreatePermissionInfoForm" >
      <div slot="title" class="dialog-footer">
          <span> 创建权限信息 </span>
      </div>
      <el-form :model="editPermissionForm" label-width="20%"> 
          <el-form-item label="权限名称:" style="width:80%" >
              <el-input v-model="createPermissionForm.permissionName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="资源地址:" style="width:80%">
              <el-input v-model="createPermissionForm.url" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注:" style="width:80%">
              <el-input type="textarea" v-model="createPermissionForm.remark" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建权限</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION} from  '@/api/constant'
export default {
  name : 'pc_ctr_permission',
  data() {
    return {
      searchFactor: {
        permissionName: ''     
      },
      tableData: [],
      pager:{
        currentPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      dialogVisual:{
        editPermissionDialogVisible: false,
        createPermissionDialogVisible: false,

      },
      editPermissionForm: {
        permissionName: '',
        url: '',
        remark: '',
        id :''
      },
      createPermissionForm: {
        permissionName: '',
        url: '',
        remark: ''
      }
    }
  },
  methods : {
    indexMethod(index){
      return  index + 1
    },
    permissionListLoad(pageNo){
      let url = "/bc/exa/permission/permissionPage"
      let { 
        permissionName
      } = this.searchFactor 
      let dat0 = {
        pageSize: PAGE_SIZE,
        permissionName,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.tableData = [];
                dat.data.forEach(t=>this.tableData.push(t))
                this.pager.totalCount = dat.totalDataCount;
                if(pageNo == 1 ) {
                this.pager.currentPage = 1
              }
            
            } else {
                this.$message({
                    showClose: true,
                    message: '未查询到权限信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                })
            }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch( (err) => {
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    clearEditPermissionInfoForm(){
      this.editPermissionForm.permissionName = ''
      this.editPermissionForm.url =''
      this.editPermissionForm.remark = ''
      this.editPermissionForm.id = ''

    },

    clearCreatePermissionInfoForm(){
      this.createPermissionForm.permissionName = ''
      this.createPermissionForm.url =''
      this.createPermissionForm.remark = ''
      
    },

    onSearch(){
      this.permissionListLoad(1)
    },
    handleEdit(index, row){
      this.dialogVisual.editPermissionDialogVisible = true
      this.editPermissionForm.permissionName = row.permissionName
      this.editPermissionForm.url = row.url
      this.editPermissionForm.remark = row.remark
      this.editPermissionForm.id = row.id
      
    },
    handleCreatePermission(){
      this.dialogVisual.createPermissionDialogVisible = true
    },
    ensureChange(){
      this.$confirm('即将更新角色['+this.editPermissionForm.permissionName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangePermissionInfo()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消更新！'
        });
      })
    },
    doChangePermissionInfo(){
      let url = "/bc/exa/permission/permissionEdit"
      let s = JSON.stringify(this.editPermissionForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.editPermissionDialogVisible= false;
          this.clearEditPermissionInfoForm();
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{ this.permissionListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreate(){
      try{ 
        stringIsNullOrEmpty(this.createPermissionForm.permissionName,'请输权限名称!');
        stringIsNullOrEmpty(this.createPermissionForm.url,'请输资源路径!');
        stringIsNullOrEmpty(this.createPermissionForm.remark,'请输权限备注!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreatePermissionInfo();
    },
    doCreatePermissionInfo(){
      let url = "/bc/exa/permission/permissionCreate"
      let s = JSON.stringify(this.createPermissionForm)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.createPermissionDialogVisible= false
          this.clearCreatePermissionInfoForm()
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{ this.permissionListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }, 
    handleCurrentChange(val){
      this.permissionListLoad(val);
    },
    handleDelete(index, row){
      this.$confirm('即将删除权限['+row.permissionName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeletePermission(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeletePermission(row){
      let datBat = [{id: row.id}]
      let url = "/bc/exa/permission/permissionDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{ this.permissionListLoad(1)},200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) =>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
  },
  created () {
    this.permissionListLoad(1);
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_permission.vue